import { Injectable } from '@angular/core';
import { EntityListResolver } from 'src/app/core/services/entity-list.resolver';
import { LiftModuleList } from '../models/lift-module-list.model';
import { LiftModuleCriteria } from '../models/lift-module.criteria';
import { LiftParameterSettingsService } from './lift-parameter-settings.service';
import { LiftParameterSettingsCriteria } from '../models/lift-parameter-settings.criteria';
import { LiftParamCriteria } from '../models/lift-param.criteria';

@Injectable({
  providedIn: 'root'
})
export class LiftParameterSettingsListResolver extends EntityListResolver<LiftParameterSettingsService, LiftModuleList, LiftParamCriteria> {
  constructor(
    liftParameterSettingsService: LiftParameterSettingsService
  ) {
    super(liftParameterSettingsService, new LiftParamCriteria());
  }
}
